import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import infoList from "@/mixins/infoList";
import { getCurrencyList, getMerchantOrderList, operationWithdrawOrder } from "@/api/merchantOrder";
export default {
  name: "TransferList",
  mixins: [infoList],
  data: function data() {
    return {
      zeroTime: null,
      currentTime: null,
      currency: '',
      listApi: getMerchantOrderList,
      currencyList: []
    };
  },
  methods: {
    getCurrency: function getCurrency() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getCurrencyList();
            case 1:
              res = _context.sent;
              if (res.code == 0) {
                _this.currencyList = res.data;
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    merchantOrder: function merchantOrder(id, msg) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return operationWithdrawOrder({
                OrderId: id,
                Sign: msg
              });
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message.success(res.msg);
              }
              _context2.next = 2;
              return _this2.getTableData();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return _this3.getTableData();
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _this4.searchInfo.StartTime = -1;
            _this4.searchInfo.EndTime = -1;
            _this4.searchInfo.OrderType = 1;
            _this4.searchInfo.CurrencyType = -1;
            _this4.getCurrency();
            _context4.next = 1;
            return _this4.getTableData();
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }
};